export const ScrapeTemplateFragment = gql`
  fragment ScrapeTemplateFragment on ScrapeTemplate {
    id
    startUrl
    crawlerType
    excludeUrlGlobs
    mostRecentScrape {
      ...ScrapeFragment
    }
  }
`
